/**
 * ソフトテンキー
 * @see 数値
 * @see ABUI_doc__Pattern_Numeric.html
 */
if(document.getElementsByClassName('js-call-tenkey')[0] != null && typeof abuiTenkey === 'undefined') {
  /**
   * ソフトウェアテンキー テンプレート
   * @type {String}
   */
  const overlayTenkey = '<div class="col-xs-6 col-sm-6 col-md-6">\
    <button class="btn btn-block brtl btn-stepper js-tenkey--minus"><span class="icon-abui-minus"></span></button>\
	</div>\
	<div class="col-xs-6 col-sm-6 col-md-6">\
	  <button class="btn btn-block brtr btn-stepper js-tenkey--plus"><span class="icon-abui-plus"></span></button>\
	</div>\
	<div class="col-xs-4 col-sm-4 col-md-4">\
	  <button class="btn btn-block">7</button>\
	</div>\
	<div class="col-xs-4 col-sm-4 col-md-4">\
	  <button class="btn btn-block">8</button>\
	</div>\
	<div class="col-xs-4 col-sm-4 col-md-4">\
	  <button class="btn btn-block">9</button>\
	</div>\
	<div class="col-xs-4 col-sm-4 col-md-4">\
	  <button class="btn btn-block">4</button>\
	</div>\
	<div class="col-xs-4 col-sm-4 col-md-4">\
	  <button class="btn btn-block">5</button>\
	</div>\
	<div class="col-xs-4 col-sm-4 col-md-4">\
	  <button class="btn btn-block">6</button>\
	</div>\
	<div class="col-xs-4 col-sm-4 col-md-4">\
	  <button class="btn btn-block">1</button>\
	</div>\
	<div class="col-xs-4 col-sm-4 col-md-4">\
	  <button class="btn btn-block">2</button>\
	</div>\
	<div class="col-xs-4 col-sm-4 col-md-4">\
	  <button class="btn btn-block">3</button>\
	</div>\
	<div class="col-xs-8 col-sm-8 col-md-8">\
	  <button class="btn btn-block brbl">0</button>\
	</div>\
	<div class="col-xs-4 col-sm-4 col-md-4">\
	  <button class="btn btn-block brbr">C</button>\
	</div>';

  /**
   * ソフトウェアテンキーを包括するテンプレート
   * @type {String}
   */
  const source = '<div class="row control-tenkey overlay-tenkey tenkey--bottom">' + overlayTenkey + '</div>';

  /**
   * テンキー表示 関数
   * @param  {Object}  ターゲットのオブジェクト
   */
  function abuiTenkey(_this) {
    'use strict';
    const getDefaultVal = parseInt(_this.value);
    const getCallTenkeyParent = _this.parentNode;
    const ctrlTenkey          = getCallTenkeyParent.getElementsByClassName('control-tenkey')[0];

    if(typeof ctrlTenkey === 'undefined') {
      /**
       * テンキーを初期化
       */
      removeTenkey();

      /**
       * テンキーを挿入
       */
      const tempElemDiv = document.createElement('div');
      tempElemDiv.innerHTML = source;
      const wrapTenkey = tempElemDiv.childNodes;
      getCallTenkeyParent.insertBefore(wrapTenkey[0], _this);

      /**
       * 対象のオブジェクトの"data-"属性の値を変更
       * @type {Boolean}
       */
      _this.dataset.open = true;

      /**
       * 対象のテンキーに"in"クラスを付与し表示(フェードイン)
       */
      window.setTimeout(function() {
        const tgtCtrlTenkey = getCallTenkeyParent.getElementsByClassName('control-tenkey')[0];
        tgtCtrlTenkey.classList.add('in');

        /**
         * 数字キー コントロール
         */
        const tgtElemTenkeyBtn = tgtCtrlTenkey.querySelectorAll('button:not(.btn-stepper)');

        for(let i=0, len=tgtElemTenkeyBtn.length; i<len; i=(i+1)|0) {
          tgtElemTenkeyBtn[i].addEventListener('click', function(event) {
            event.stopPropagation();

            const getPressBtn = this.textContent;

            /**
             * 結果表示
             * @type {String}
             */
            let result = _this.value;

            /**
             * クリアーを押した時
             * 入力された数値を'0'に
             */
            if(getPressBtn === 'C') {
              result      = '';
              _this.value = 0;
              return false;
            } else {

              /**
               * 押されたボタンの番号を数値化
               * @type {Number}
               */
              const setNumBtn = parseInt(getPressBtn);

              /**
               * 初期値と押した数字が同じ時
               *   0以外は連続入力可能
               */
              if(getDefaultVal !== setNumBtn && setNumBtn !== 0) {
                result      = result + setNumBtn;
                _this.value = parseInt(result);
              } else {
                /**
                 * 入力数値が'0'で桁数が1桁目の時
                 */
                if(result.length > '1') {
                  _this.value = result + setNumBtn;
                } else {
                  return false;
                }
              }
            }
          });
        }

        /**
         * ステッパーキー コントロール
         */
        const tgtSymbolTenKey = tgtCtrlTenkey.getElementsByClassName('btn-stepper');
        for(let i=0, len=tgtSymbolTenKey.length; i<len; i=(i+1)|0) {
          tgtSymbolTenKey[i].addEventListener('click', function(event) {
            event.stopPropagation();

            /**
             * '+'  1ずつ増える
             * '-'  1ずつ減る
             */
            let getResult = parseInt(_this.value);
            if(this.classList.contains('js-tenkey--minus')) {
              getResult -= 1;
              _this.value = getResult;
            } else if(this.classList.contains('js-tenkey--plus')) {
              getResult += 1;
              _this.value = getResult;
            }
          });
        }
      });
    }
  }

  /**
   * テンキー削除 関数
   * @type  {Function}
   */
  function removeTenkey() {
    const tgtElemTenkey = document.getElementsByClassName('control-tenkey');
    for(let i=0, len=tgtElemTenkey.length; i<len; i=(i+1)|0) {
      if(tgtElemTenkey[i].classList.contains('in')) {
        const tgtElemTenkeyParent = tgtElemTenkey[i].parentNode;
        const setElemCallTenkey   = tgtElemTenkeyParent.getElementsByClassName('js-call-tenkey')[0];
        setElemCallTenkey.dataset.open = false;
        tgtElemTenkeyParent.removeChild(tgtElemTenkey[i]);
      }
    }
  }


  /**
   * フィールドに直接入力する時
   */
  {
    const tgtTxtField = document.getElementsByClassName('js-call-tenkey');
    let flag = 0;
    for(let i=0, len=tgtTxtField.length; i<len; i=(i+1)|0) {
      tgtTxtField[i].addEventListener('keydown', function(e) {
        e.stopPropagation();
        /**
         * 押されたキーを取得
         * @type {String}
         */
        const keyName = e.key;

        /**
         * 取得したキーを数値変換
         * @type {Number}
         */
        const numKeyName = parseInt(keyName);

        /**
         * 結果表示
         */
        let result_direct = this.value;

        const getTxtFieldParent = this.parentNode;

        if(!this.value.match(/[^0-9]+/)) {
          /**
           * 初期値と押した数字が同じ時
           *   0以外は連続入力可能
           */
          if(result_direct !== keyName && keyName !== '0') {
            if(flag === 0) {
              result_direct = '';
              this.value = result_direct;
              flag = 1;
            } else {
              return false;
            }
          } else {
            if(result_direct.length < 2) {
              this.value = '';
            }
          }
        }
        // } else {
        //   getTxtFieldParent.classList.add('has-error');
        // }
      });
    }
  }


  /**
   * テンキー以外の要素を取得
   * @type {Object}
   */
  const tgtElemWithoutTenkey = document.querySelectorAll('body :not(.js-call-tenkey)');

  let j = 0, length;
  for(j=0, length=tgtElemWithoutTenkey.length; j<length; j=(j+1)|0) {
    /**
     * テンキー以外の要素をクリック
     * @summary  テンキーを非表示 制御
     */
    tgtElemWithoutTenkey[j].removeEventListener('click', removeTenkey);
    tgtElemWithoutTenkey[j].addEventListener('click', removeTenkey);
  }
}
